// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-card{position:relative}.search-card>a{display:block;position:relative;color:inherit}.search-card>a:hover,.search-card>a:active,.search-card>a:focus,.search-card>a:not(:active){text-decoration:none;border:none}.search-card .search-card-front:hover+.search-card-back{height:100% !important}\n", ""]);
// Exports
module.exports = exports;
